import React, { useState } from 'react'
import Sidebar from '../../components/sidebar/Sidebar'

const PRIMARY = '#3661EB'
const GREY = '#9B9B9B'
const BORDER = '#ECEEF2'
const ROW_HIGHLIGHT = '#EBF0FE'

const mockData = [
  { niy: '12345678', nama: 'Samuel Umtiti', mapel: 'Matematika', kelas: '11 PPLG 1' },
  { niy: '12345678', nama: 'Muhammad Firdan Azhari', mapel: 'Android Development', kelas: '12 PPLG 1' },
  { niy: '12345678', nama: 'Antariksa Kusuma Harmawan', mapel: 'Matematika', kelas: '11 PPLG 1' },
  { niy: '12345678', nama: 'Samuel Umtiti', mapel: 'Matematika', kelas: '11 PPLG 1' },
  { niy: '12345678', nama: 'Samuel Umtiti', mapel: 'Matematika', kelas: '11 PPLG 1' },
  { niy: '12345678', nama: 'Muhammad Firdan Azhari', mapel: 'Matematika', kelas: '11 PPLG 1' },
  { niy: '12345678', nama: 'Antariksa Kusuma Harmawan', mapel: 'Matematika', kelas: '11 PPLG 1' },
  { niy: '12345678', nama: 'Samuel Umtiti', mapel: 'Matematika', kelas: '11 PPLG 1' },
]

function AssignGuruSiswa() {
  const [search, setSearch] = useState('')
  const [currentPage, setCurrentPage] = useState(1)

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#fff', fontFamily: 'Poppins, sans-serif' }}>
      {/*<Sidebar />*/}

      <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        {/* Top Bar */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 40px', borderBottom: `1px solid ${BORDER}` }}>
          <div style={{ position: 'relative' }}>
            <span style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: GREY }}>🔍</span>
            <input
              type="text"
              placeholder="Cari Wali Kelas"
              value={search}
              onChange={e => setSearch(e.target.value)}
              style={{ paddingLeft: 36, paddingRight: 12, height: 48, width: 357, border: 'none', background: '#F3F3F3', borderRadius: 5, fontSize: 14, color: GREY, outline: 'none' }}
            />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <div style={{ width: 40, height: 40, borderRadius: '50%', background: BORDER, overflow: 'hidden' }}>
              <img src="https://i.pravatar.cc/40" alt="admin" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </div>
            <span style={{ fontSize: 14, fontWeight: 500 }}>User Admin</span>
            <span style={{ color: GREY }}>▾</span>
          </div>
        </div>

        {/* Content */}
        <div style={{ padding: '24px 40px', flex: 1 }}>
          {/* Header Row */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
            <h2 style={{ fontSize: 24, fontWeight: 500, margin: 0 }}>Wali Kelas</h2>
            <div style={{ display: 'flex', gap: 10 }}>
              <button style={{ background: PRIMARY, color: '#fff', border: 'none', borderRadius: 5, padding: '12px 36px', fontSize: 14, fontWeight: 500, cursor: 'pointer' }}>
                + Add New
              </button>
              <button style={{ background: PRIMARY, color: '#fff', border: 'none', borderRadius: 5, padding: '12px 36px', fontSize: 14, fontWeight: 500, cursor: 'pointer' }}>
                Import
              </button>
            </div>
          </div>

          {/* Table Card */}
          <div style={{ border: `1px solid ${BORDER}`, borderRadius: 10, overflow: 'hidden' }}>
            {/* Tab */}
            <div style={{ borderBottom: `1px solid ${BORDER}`, padding: '0 20px' }}>
              <span style={{ display: 'inline-block', padding: '16px 0', fontSize: 14, fontWeight: 500, color: PRIMARY, borderBottom: `2px solid ${PRIMARY}` }}>
                Siswa
              </span>
            </div>

            {/* Table Header */}
            <div style={{ display: 'grid', gridTemplateColumns: '100px 1fr 1fr 1fr 60px', padding: '12px 20px', background: '#fff', borderBottom: `1px solid ${BORDER}` }}>
              <span style={{ fontSize: 14, fontWeight: 500 }}>NIY</span>
              <span style={{ fontSize: 14, fontWeight: 500 }}>Nama Wali Kelas</span>
              <span style={{ fontSize: 14, fontWeight: 500 }}>Mapel</span>
              <span style={{ fontSize: 14, fontWeight: 500 }}>Kelas</span>
              <span></span>
            </div>

            {/* Table Rows */}
            {mockData.map((row, i) => (
              <div
                key={i}
                style={{
                  display: 'grid',
                  gridTemplateColumns: '100px 1fr 1fr 1fr 60px',
                  padding: '14px 20px',
                  background: i % 2 === 0 ? ROW_HIGHLIGHT : '#fff',
                  alignItems: 'center',
                }}
              >
                <span style={{ fontSize: 10, color: PRIMARY, fontWeight: 500 }}>{row.niy}</span>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <img src={`https://i.pravatar.cc/35?img=${i + 1}`} alt="" style={{ width: 35, height: 35, borderRadius: '50%' }} />
                  <span style={{ fontSize: 10, color: GREY }}>{row.nama}</span>
                </div>
                <span style={{ fontSize: 10, color: GREY }}>{row.mapel}</span>
                <span style={{ fontSize: 10, color: GREY }}>{row.kelas}</span>
                <div style={{ display: 'flex', gap: 8 }}>
                  <span style={{ cursor: 'pointer', color: '#ccc' }}>📋</span>
                  <span style={{ cursor: 'pointer', color: '#FFC107' }}>✏️</span>
                  <span style={{ cursor: 'pointer', color: '#F44336' }}>🗑️</span>
                </div>
              </div>
            ))}
          </div>

          {/* Pagination */}
          <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginTop: 24 }}>
            <button style={{ width: 32, height: 32, border: `1px solid ${BORDER}`, borderRadius: 4, background: '#919EAB80', cursor: 'not-allowed' }}>‹</button>
            {[1, 2, '...', 9, 10].map((page, i) => (
              <button
                key={i}
                onClick={() => typeof page === 'number' && setCurrentPage(page)}
                style={{
                  width: 32, height: 32, borderRadius: 4, border: currentPage === page ? `1.5px solid ${PRIMARY}` : `1px solid ${BORDER}`,
                  background: '#fff', color: currentPage === page ? PRIMARY : '#000',
                  fontWeight: currentPage === page ? 700 : 600, fontSize: 14, cursor: 'pointer',
                }}
              >
                {page}
              </button>
            ))}
            <button style={{ width: 32, height: 32, border: `1px solid ${BORDER}`, borderRadius: 4, background: '#fff', cursor: 'pointer' }}>›</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AssignGuruSiswa
